<template>
  <div :class="{ news: true, 'with-footer': this.$route.name !== 'ptclDetailLink' }" id="news">
    <div v-if="this.$route.name !== 'ptclDetailLink'" class="headline">
      <div class="wrapper animated fadeInUp">
        <div class="title">{{ $t('nav.news') }}</div>
      </div>
    </div>
    <div class="wrapper lighter">
      <router-view></router-view>
    </div>
    <Footer v-if="this.$route.name !== 'ptclDetailLink'"></Footer>
  </div>
</template>

<script>
export default {
  name: 'News',
  components: {
    Footer: () => import('@/components/Footer.vue')
  },
  data() {
    return {
      newsList: [
        {
          date: '2019-03-15',
          title: 'Dizal Announces Successful Completion of IND filing with NMPA for AZD4205',
          intro: 'March 13, 2019 (GMT+8) - NMPA completed the review of AZD4205 IND (Investigational New Drug) application and concluded that Dizal Pharmaceutical may proceed with their proposed clinical investigation.'
        },
        {
          date: '2018-12-27',
          title: 'Dizal Announces CDE Acceptance of IND Application for AZD4205',
          intro: 'December 24, 2018 (GMT+8) – The Center for Drug Evaluation, China Food and Drug Administration (CDE) accepted IND application for AZD4205. '
        },
        {
          date: '2018-11-14',
          title: 'Dizal Announces AZD4205 Achieving First Time in Man in US',
          intro: 'November 12, 2018(GMT-4), AZD4205 achieved First Time in Man in US.'
        },
        {
          date: '2017-11-27',
          title: 'AstraZeneca and Chinese Future Industry Investment Fund establish joint venture to develop new medicines in China',
          intro: 'Collaboration aims to accelerate local development of innovative medicines for patients in China and builds on AstraZeneca’s strong presence in the country'
        }
      ]
    }
  },
  methods: {}
}
</script>

<style lang="less" scoped>
#news {
  &.with-footer {
    padding-top: 410px;
  }
  width: 100%;
  // min-height: 100%;
  // 研发 slogan
  .headline {
    margin-bottom: 50px;
    background-image: url(/static/images/news_top.jpg);
  }
  & > .wrapper {
    padding: 0 0 50px;
  }
}
@media screen and (max-width: 750px) {
  #news {
    .headline {
      background-image: url(/static/images/news_top_M.jpg);
      & > .wrapper {
        top: 105px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/news/index.vue